import { CreditCard, Wallet, Clock, Smartphone, DollarSign } from "lucide-react";

const ICON = {
  stripe:          CreditCard,
  card:            CreditCard,
  credit_card:     CreditCard,
  applepay:        Smartphone,
  googlepay:       Smartphone,
  cashapp:         Wallet,
  venmo:           Wallet,
  zelle:           Wallet,
  cash_on_arrival: Clock,
  pay_later:       Clock,
  cash:            DollarSign,
};
const LABEL = {
  stripe:          "Credit Card (Stripe)",
  card:            "Credit Card",
  credit_card:     "Credit Card",
  applepay:        "Apple Pay",
  googlepay:       "Google Pay",
  cashapp:         "Cash App",
  venmo:           "Venmo",
  zelle:           "Zelle",
  cash_on_arrival: "Pay Later",
  pay_later:       "Pay Later",
  cash:            "Cash",
};
const TONE = {
  stripe:          "bg-violet-50 text-violet-800 border-violet-200",
  card:            "bg-violet-50 text-violet-800 border-violet-200",
  credit_card:     "bg-violet-50 text-violet-800 border-violet-200",
  applepay:        "bg-gray-100 text-gray-900 border-gray-200",
  googlepay:       "bg-blue-50 text-blue-800 border-blue-200",
  cashapp:         "bg-emerald-50 text-emerald-800 border-emerald-200",
  venmo:           "bg-sky-50 text-sky-800 border-sky-200",
  zelle:           "bg-indigo-50 text-indigo-800 border-indigo-200",
  cash_on_arrival: "bg-amber-50 text-amber-800 border-amber-200",
  pay_later:       "bg-amber-50 text-amber-800 border-amber-200",
  cash:            "bg-amber-50 text-amber-800 border-amber-200",
};

/**
 * Compact chip showing the customer's selected payment method.
 * Renders a label + lucide icon + colored pill, never throws on unknown methods.
 */
export default function PaymentMethodChip({ method, methodLabel, size = "sm", className = "" }) {
  const key = String(method || "").toLowerCase();
  const Icon = ICON[key] || DollarSign;
  const tone = TONE[key] || "bg-gray-100 text-gray-700 border-gray-200";
  const label = methodLabel || LABEL[key] || (method ? String(method).replace(/_/g, " ") : "—");
  const sz = size === "lg" ? "text-[11px] px-2.5 py-1" : "text-[10px] px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 ${sz} font-extrabold uppercase tracking-[0.12em] rounded-full border ${tone} ${className}`}
      data-testid={`payment-method-chip-${key || "unknown"}`}
    >
      <Icon className="w-3 h-3" />
      <span>{label}</span>
    </span>
  );
}
